import { render, staticRenderFns } from "./header-form.vue?vue&type=template&id=40d5c6d0"
import script from "./header-form.vue?vue&type=script&lang=js"
export * from "./header-form.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports